import { message } from "antd";
import { domainUrl } from "../../constants";
import { checkAuthorization } from "../../helpers";

const sendJobApplication = (formData) => {

    const { userToken } = checkAuthorization()
    const myHeaders = new Headers()
    myHeaders.append('Authorization', userToken)
    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formData,
        redirect: 'follow'
    }

    const url = '/sendJobApplication'
    return (
        fetch(domainUrl + url, requestOptions)
        .then(response => response.json())
        .then(result => {
            if (result?.success) {
                message.success(result?.message || 'Job application submitted successfully!')
                return 1
            }
            else 
                throw result?.message
        })
        .catch(error => {
            message.error(error.message || 'Something went wrong while submitting the job application.')
            return 0
        })
    )
}

const jobApplicationApi = {
    sendJobApplication,
};

export { jobApplicationApi };